import { GraphQLService } from 'services/GraphQLService/GraphQLService';
import { axiosInstance } from './axios';

export const graphQLService = new GraphQLService(axiosInstance);
